import { Injectable } from '@angular/core';
import { CurrencyLocaleData, getCurrencyLocaleDataByCountryCode } from '@pedix-workspace/utils';
import { CurrencyFormatService } from '@pedix-workspace/pedixapp-shared-pipes';

@Injectable()
export class AppCurrencyFormatService extends CurrencyFormatService {
  currencyCode: string;

  get currencyLocaleData(): CurrencyLocaleData {
    return getCurrencyLocaleDataByCountryCode(this.currencyCode);
  }
}
